import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import CircularProgress from "../Generic/CircularProgress";
import { GlobalContext } from "../../context";
import client from "../../api/client";

const ProfilePictureUploader = () => {
  const { authDispatch, authState } = useContext(GlobalContext);
  const [preview, setPreview]   = useState(null);
  const [loading, setLoading]   = useState(false);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setPreview(URL.createObjectURL(file));
    setLoading(true);

    try {
      const token = localStorage.getItem("nd-rest-tkn");
      if (token) client.defaults.headers.Authorization = `Bearer ${token}`;

      const fd = new FormData();
      fd.append("image", file);

      const res = await client.post("/user/profile-image", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const newUrl = res.data.url;

      // Update localStorage so next page load gets the new image
      const stored = localStorage.getItem("userData");
      if (stored) {
        try {
          const userData = JSON.parse(stored);
          userData.profile_img = newUrl;
          localStorage.setItem("userData", JSON.stringify(userData));
        } catch (_) {}
      }

      // Update global auth state directly — bypasses the GET cache on /user
      authDispatch({
        type: "SUCCESS",
        payload: {
          user: { ...(authState.data?.user ?? {}), profile_img: newUrl },
          token,
        },
      });

      toast.success("Profile picture updated!");
    } catch (err) {
      console.error("Profile picture upload error:", err);
      const msg = err?.response?.data?.message || err?.message || "Could not upload profile picture.";
      toast.error(msg);
      setPreview(null);
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  const currentImg = preview || authState?.data?.user?.profile_img;

  return (
    <div className="flex flex-col items-center gap-4">
      {/* Avatar */}
      <div className="relative w-28 h-28">
        {currentImg ? (
          <img
            src={currentImg}
            alt="Profile"
            className="w-full h-full object-cover rounded-full border-2 border-gray-100"
          />
        ) : (
          <div className="w-full h-full rounded-full bg-gray-200 flex items-center justify-center">
            <svg className="w-14 h-14 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
            </svg>
          </div>
        )}

        {/* Loading overlay */}
        {loading && (
          <div className="absolute inset-0 rounded-full bg-black/40 flex items-center justify-center">
            <CircularProgress />
          </div>
        )}
      </div>

      {/* Hidden file input */}
      <input
        id="profileFileInput"
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        className="hidden"
      />

      <label
        htmlFor="profileFileInput"
        className={`px-4 py-2 rounded-xl text-sm font-semibold cursor-pointer transition-colors
          ${loading
            ? "bg-gray-200 text-gray-400 cursor-not-allowed pointer-events-none"
            : "bg-[#294a93] hover:bg-[#1e3a7a] text-white"}`}
      >
        {loading ? "Uploading…" : currentImg ? "Change Photo" : "Upload Photo"}
      </label>
    </div>
  );
};

export default ProfilePictureUploader;
